export default __webpack_public_path__ + "static/media/band-aid.f6a8ad52.png";